<template>
  <a
    class="mo-auth"
    :href="moAuthUrl"
  >
    <span class="mo-auth__text">Войти с помощью</span>
    <span class="mo-auth__icon" />
  </a>
</template>

<script setup lang="ts">
const moAuthUrl = computed(
  () =>
    window &&
    `${window.location.origin}/api/auth/motmom/sign-in?back_url=${window.location.origin}`,
);
</script>

<style scoped lang="scss">
.mo-auth {
  display: flex;
  align-items: baseline;
  justify-content: center;
  margin-top: 40px;
  text-decoration: none;
  color: #656565;

  &__text {
    border-bottom: 1px solid #656565;
    font-family: 'Gilroy', sans-serif;
    font-weight: 500;
    font-size: 16px;
    letter-spacing: 0.5px;
  }

  &__icon {
    width: 28px;
    height: 16px;
    margin-left: 8px;
    background-image: url('./images/mo-logo-grey.svg');
    background-size: 28px;
    background-repeat: no-repeat;
  }

  &:hover {
    opacity: 0.8;

    .mo-auth__icon {
      background-image: url('./images/mo-logo-color.svg');
    }
  }
}
</style>
